<template>
  <DashboardVideo />
  <div
    class="container h-100 d-flex align-items-unset justify-content-center z-2"
  >
    <div class="row mobile align-content-unset g-0">
      <div
        class="col-12 d-flex ps-3 pe-3 align-items-center justify-content-between theme-header"
      >
        <a
          href="https://tool.metaluxe.com.au/"
          target="_blank"
          class="annotation mb-3"
          data-bs-toggle="tooltip"
          title="Click to Edits"
        >
          <img src="/img/ui-theme/key-white.svg" class="key-icon" />
        </a>

        <a href="#" class="mx-auto">
          <img :src="`/img/ui-theme/` + theme.devLogo" class="devlogo" />
        </a>

        <button
          class="btn text-light"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
          style="padding-right: 0; padding-left: 0"
        >
          <h5 class="nav-title">REGISTER</h5>
        </button>
      </div>
      <div class="col-12 d-flex align-items-unset justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link
              :to="{
                name: 'VideoView',
                params: {
                  guid: 'dc53fddf-5e48-48a2-abd9-767337d0ef5f',
                  collectionId: '539363',
                },
              }"
              class="border-top-right-radius btn-theme-menu mb-2 flex"
            >
              <div class="flex-1">
                <img
                  :src="theme.CinematicsIcon"
                  alt="CinematicsIcon"
                  class="ms-4"
                  style="margin-right: 27px"
                />
              </div>
              <span className="video-label flex-1 ">Cinematics</span>
            </router-link>

            <router-link
              :to="{
                name: 'AssetView',
                params: {
                  assetType: 'type1',
                  viewType: 'renders',
                },
              }"
              class="btn-theme-menu mb-2 flex"
              style="gap: 0"
            >
              <div class="flex-1">
                <img
                  :src="theme.rendersIcon"
                  alt="panoramasIcon"
                  class="video-icon"
                  style="margin-left: -26px"
                />
              </div>
              <span className="video-label flex-1" style="padding-left: 40px"
                >Stills</span
              >
            </router-link>

            <router-link
              :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: 'sunset',
                  viewType: '360-tour',
                  order: 0,
                },
              }"
              class="border-bottom-left-radius btn-theme-menu mb-2 flex"
            >
              <div class="flex-1">
                <img
                  :src="theme.panoramasIcon"
                  alt="panoramasIcon"
                  class="me-3 video-icon"
                  style="margin-left: -8px"
                />
              </div>
              <span className="video-label flex-1">Balcony</span>
            </router-link>

            <!-- <router-link
              :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: 'Rana',
                  viewType: 'balcony-views',
                  order: 0,
                },
              }"
              class="btn-theme-menu mb-2 border-bottom-left-radius"
            >
              <img
                :src="theme.panoramasIcon"
                alt="virtual-tour"
                class="me-3 ms-4 video-icon"
              />
              <span className="video-label">Balcony Views</span>
            </router-link> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from '@/components/DashboardVideo.vue'
import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'
import BunnyNetService from '@/services/BunnyNetService.js'
import { unslugify } from 'unslugify'
import sortArray from 'sort-array'

export default {
  name: 'DashboardHome',
  components: {
    DashboardVideo,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      componentName: 'AssetType',
      componentAdmin: 'Admin',
      folderStructure: encodeURIComponent(
        this.theme.devFolder + '/assets/' + 'type1' + '/'
      ),
      brochureUrl: '',
    }
  },
  created() {
    // BunnyNetService.getFolders(this.folderStructure)
    //   .then((response) => {
    //     // Remap array
    //     console.log(response.data)
    //     const menuItems = response.data.map((item) => {
    //       return {
    //         Guid: item.Guid,
    //         ObjectName: unslugify(item.ObjectName),
    //         LinkName: item.ObjectName,
    //         ComponentName: this.componentName,
    //         Path: item.Path,
    //         IsDirectory: item.IsDirectory,
    //         StorageZoneName: item.StorageZoneName,
    //       }
    //     })
    //     const customMenu = sortArray(menuItems, {
    //       by: ['LinkName'],
    //       order: 'LinkName',
    //       customOrders: {
    //         LinkName: this.theme.assetsMenuOrder,
    //       },
    //     })
    //     this.assetTypes = customMenu
    //   })
    //   .catch((error) => {
    //     console.log('this is error')
    //     console.log(error)
    //   })
  },
  setup() {
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
